export default function logUserOut(storeParam) {
  let store;

  if (storeParam) {
    store = storeParam;
  } else {
    store = this.$store;
  }

  store.commit('userData', null);

  let router;

  import('../router').then(async (res) => {
    router = res.default;

    if (router.currentRoute.name !== 'home') {
      await router.push({ name: 'home' });
    }
  });
}
